module.exports = __webpack_public_path__ + "img/avatar-white.b1cd4869.svg";